import React from 'react';
import {IconProps} from "../services/IconConstants";

const HomeIcon = ({size, colour, style, className}: IconProps) => {

    return (
        <svg viewBox="0 0 24 24"
             width={size}
             height={size}
             color={colour ? colour : 'var(--text)'}
             style={style}
             className={className}
             fill={"none"}>
            <path d="M9 22L9.00279 16.9994C9.0031 16.4474 9.45073 16 10.0028 16L14 16C14.5523 16 15 16.4477 15 17V22"
                  stroke="currentColor" stroke-width="1.5"/>
            <path
                d="M3 20V10.065C3 9.45242 3.28074 8.87362 3.76182 8.49437L10.7618 2.97609C11.488 2.40361 12.512 2.40361 13.2382 2.97609L20.2382 8.49437C20.7193 8.87362 21 9.45243 21 10.065V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20Z"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}

export default HomeIcon;